import { render, staticRenderFns } from "./AppWthdrPage.vue?vue&type=template&id=b85227fc&scoped=true"
import script from "./AppWthdrPage.vue?vue&type=script&lang=js"
export * from "./AppWthdrPage.vue?vue&type=script&lang=js"
import style0 from "./AppWthdrPage.vue?vue&type=style&index=0&id=b85227fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85227fc",
  null
  
)

export default component.exports